import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const EventListItemRow = ({
   borderColor,
   coverMedia,
   name,
   linkTo,
   location,
   privacy,
   startDate,
   startTime,
   textColor,
   textSize,
   virtual
}) => (
   <Link to={linkTo}>
      <View
         display="flex"
         alignItems="center"
         height="50px[c-f]"
         padding="10px 0px[a-b]"
         borderBottom={`1px solid ${borderColor}`}>
         <View
            flex="0 0 auto"
            width="25px"
            height="25px"
            position="relative"
            backgroundColor="#eee"
            backgroundImage={coverMedia && `url(${coverMedia?.file.thumbnailUrlW480})`}
            backgroundSize="cover"
            backgroundPosition="bottom center"
            backgroundRepeat="no-repeat"
            borderRadius="3px"
            marginRight="20px"
         />
         <View display="flex" flex="1 1 auto" flexFlow="column[a-b] row[c-f]">
            <View flex="1 1 auto" opacity="0.8">
               <Text size="2" color={textColor} weight="medium">
                  {name}
               </Text>
            </View>
            <View display="flex" flex="0 0 auto">
               {['admin', 'draft', 'private'].includes(privacy) && (
                  <>
                     <View flex="0 0 auto" width="140px[c-f]" opacity="0.5">
                        <Text size="1.5" color={textColor} transform="capitalize">
                           {privacy !== 'admin' && privacy}
                           {privacy === 'admin' && 'Admin-only'}
                        </Text>
                     </View>
                     <View display="block[a-b] none[c-f]" padding="0px 5px" opacity="0.5">
                        <Text size="1.5" color={textColor}>—</Text>
                     </View>
                  </>
               )}
               <View flex="0 0 auto" width="180px[c-f]" opacity={!virtual && '0.5'}>
                  <Text size="1.5" color={virtual ? '#eb8044' : textColor}>
                     {virtual && 'Online'}
                     {!virtual && (location.city || location.state) && `${location.city}${location.city && location.state && ', '}${location.state}`}
                  </Text>
               </View>
               {startDate && (
                  <View display="block[a-b] none[c-f]" padding="0px 5px" opacity="0.5">
                     <Text size="1.5" color={textColor}>—</Text>
                  </View>
               )}
               <View flex="0 0 auto" width="140px[c-f]" opacity="0.5">
                  <Text size="1.5" color={textColor}>
                     {startDate}
                  </Text>
               </View>
               {startTime && (
                  <View display="block[a-b] none[c-f]" padding="0px 5px" opacity="0.5">
                     <Text size="1.5" color={textColor}>—</Text>
                  </View>
               )}
               <View flex="0 0 auto" width="100px[c-f]" opacity="0.5">
                  <Text size="1.5" color={textColor}>
                     {startTime}
                  </Text>
               </View>
            </View>
         </View>
      </View>
   </Link>
)

EventListItemRow.propTypes = {
   borderColor: PropTypes.string.isRequired,
   coverMedia: PropTypes.object,
   name: PropTypes.string.isRequired,
   linkTo: PropTypes.string.isRequired,
   location: PropTypes.object,
   privacy: PropTypes.string.isRequired,
   startDate: PropTypes.string,
   startTime: PropTypes.string,
   textColor: PropTypes.string.isRequired,
   textSize: PropTypes.string.isRequired,
   virtual: PropTypes.bool.isRequired
}

EventListItemRow.defaultProps = {
   coverMedia: undefined,
   location: undefined,
   startDate: undefined,
   startTime: undefined
}

export default EventListItemRow
